import { DataCenterAttribute, Hub } from '@bimone/bimtrack-core';
import { HubPersistDto } from '../types';

export function serializeHub(hub?: Hub): HubPersistDto | undefined {
  if (!hub) {
    return undefined;
  }

  const {
    globalId,
    hashId,
    localId,
    name,
    dataCenterInfo: { id: dataCenterId, name: dataCenterName },
    bimTrackRegionalApiUrl,
  } = hub;

  return {
    globalId,
    hashId,
    localId,
    name,
    dataCenterInfo: {
      id: dataCenterId,
      name: dataCenterName,
    },
    bimTrackRegionalApiUrl,
  };
}

export function deserializeHub(hub?: HubPersistDto): Hub | undefined {
  if (!hub) {
    return undefined;
  }

  const {
    globalId,
    hashId,
    localId,
    name,
    dataCenterInfo: { id: dataCenterId, name: dataCenterName },
    bimTrackRegionalApiUrl,
  } = hub;

  return new Hub({
    globalId,
    hashId,
    localId,
    name,
    dataCenterInfo: new DataCenterAttribute({
      id: dataCenterId,
      name: dataCenterName,
    }),
    bimTrackRegionalApiUrl,
  });
}
